import StoredLayout from 'layouts/StoredLayout';
import React from 'react';
import { Container } from 'reactstrap';
import { Row, Col } from 'reactstrap';

// SGBC custom components
import PayNowPanel from './components/PayNowPanel';

class EventPayNowPage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <br />
                        <PayNowPanel {...this.props} />
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default StoredLayout(EventPayNowPage);
